import { Customer, PhoneNumberConfig, Result } from '../Api';
import axios, { AxiosRequestConfig, throwIfServerError } from './apiServices';

//#region LOGIN

type RequestSmsCodeProps = {
  PhoneNumber: string;
  DeviceName?: string;
  WlId?: string;
};
export const requestSmsCode = async (
  props: RequestSmsCodeProps,
  config?: AxiosRequestConfig
) => {
  try {
    const commonHeaders = { ...axios.defaults.headers.common };
    delete commonHeaders['X-Flipdish-Token'];

    await axios.post(`/Account/RequestPhoneLoginCodeSms`, props, {
      withCredentials: false,
      headers: {
        common: commonHeaders
      }
    });
  } catch (error) {
    throwIfServerError(error);
  }
};

export const logout = async (config?: AxiosRequestConfig) => {
  await axios.post(`/Account/LogOff`, undefined, config);
};

//#endregion

//#region GET
export const get = async (config?: AxiosRequestConfig) => {
  try {
    const result = await axios.get<Result<Customer>>(
      `/account/accountdetails`,
      config
    );

    return result.data.Data;
  } catch (error) {
    throwIfServerError(error);
  }
};
//#endregion

//#region SET_NAME
type SetNameProps = {
  customerName: string;
};
export const setName = async (
  props: SetNameProps,
  config?: AxiosRequestConfig
) => {
  try {
    await axios.put(`/Account/CustomerName`, props, config);
  } catch (error) {
    throwIfServerError(error);
  }
};
//#endregion

//#region SET_EMAIL
type SetEmailProps = {
  Email: string;
};
export const setEmail = async (
  props: SetEmailProps,
  config?: AxiosRequestConfig
) => {
  try {
    await axios.put(`/Account/SetEmailAddress`, props, config);
  } catch (error) {
    throwIfServerError(error);
  }
};
//#endregion

//#region SET_LANGUAGE
type SetLanguageProps = {
  id: string;
};
export const setLanguage = async (
  props: SetLanguageProps,
  config?: AxiosRequestConfig
) => {
  try {
    await axios.put(`/Account/Language`, props, config);
  } catch (error) {
    throwIfServerError(error);
  }
};
//#endregion

//#region SET_OVER_ALCOHOL_AGE_LIMIT
type SetOverAlcoholAgeLimitProps = {
  id: boolean;
};
export const setOverAlcoholAgeLimit = async (
  props: SetOverAlcoholAgeLimitProps,
  config?: AxiosRequestConfig
) => {
  try {
    await axios.put(`/Account/OverAlcoholAgeLimit`, props, config);
  } catch (error) {
    throwIfServerError(error);
  }
};
//#endregion

//#region SET_SMS_PROMOTION
type SetSmsPromotionsProps = {
  enabled: boolean;
};
export const setSmsPromotions = async (
  props: SetSmsPromotionsProps,
  config?: AxiosRequestConfig
) => {
  try {
    await axios.put(`/Account/SmsPromotionsEnabledFlag`, props, config);
  } catch (error) {
    throwIfServerError(error);
  }
};
//#endregion

//#region SET_Consent
type SetConsentProps = {
  id: boolean;
};
export const setConsent = async (
  props: SetConsentProps,
  config?: AxiosRequestConfig
) => {
  try {
    await axios.put(`/Account/Consent`, props, config);
  } catch (error) {
    throwIfServerError(error);
  }
};
//#endregion

//#region PhoneNumberConfig

type PhoneNumberConfigProps = {
  Latitude: number;
  Longitude: number;
};
export const getPhoneNumberConfig = async (
  props: PhoneNumberConfigProps,
  config?: AxiosRequestConfig
) => {
  try {
    const result = await axios.get<Result<PhoneNumberConfig>>(
      `/Account/PhoneNumberConfig`,
      {
        params: props,
        withCredentials: false
      }
    );

    return result.data.Data;
  } catch (error) {
    throwIfServerError(error);
  }
};

//#endregion
